<template>
  <!-- <button class="custom-button" @click="handleClick">
    {{ label }}
  </button> -->
  <button @click="handleClick" type="submit" class="custom-button">
    {{ label }}
  </button>
  <!-- <v-btn class="custom-button" @click="handleClick">{{label}}</v-btn> -->
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.custom-button {
  background-color: rgb(102, 9, 255);
  color: white;
  height: 42px;
  width: 400px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(102, 9, 255, 0.9);
  }
}
</style>
